export const recommendPlanTags = {
  recommendPlanStatus: 'recommendPlanStatus',
} as const;
